module.exports = __webpack_public_path__ + "3fafb4a0af8b2a0baee7246076a263f9.png";